<template>
  <v-container class="grey lighten-5">
    <div class="my-3" >
      <!-- <v-btn icon :to="{ path: '/mymachine', query: { id: this.machineid }}"> -->
      <v-btn icon @click="$router.back()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span class="display-1 px-3" id="title">{{AnalizeTypeCategory}}の分析サンプルの{{ samplingmode }}</span>
    </div>

    <v-form ref="sampling_form">
      <v-stepper
        v-model="e6"
        vertical
        editable
      >
      <v-stepper-step :complete="e6 > 1" step="1" editable color="teal darken-1">
        オイル情報の入力
      </v-stepper-step>
      <v-stepper-content step="1" >
        <v-card class="py-2">

          <v-row dense>
            <v-col cols="10" xl="3" lg="3" md='3' sm='10' xs="10" dense>
              <v-select
                v-model="OilTypeCategory"
                :label="getItemName('オイルの種類')[AnalizeTypeCategory+'label']"
                :items="oilTypeCategoryList"
                item-value="Value"
                item-text="Text"
                @change="changeOilTypeCategory()"
                @input="$v.OilTypeCategory.$touch()"
                :error-messages="OilTypeCategoryErrors"
                :error="$v.OilTypeCategory.$error"
                :messages="getItemName('オイルの種類')[AnalizeTypeCategory+'message']"
              >
                <template v-slot:prepend-inner v-if="getItemName('オイルの種類')[AnalizeTypeCategory+'証明書']">
                  <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                </template>
              </v-select>
            </v-col>
            <v-col cols="1" lg="1" md='1' sm='2' xs="2" align-self="center" dense>
              <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
            </v-col>

            <v-col cols="10" xl="3" lg="3" md='3' sm='10' xs="10" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-select
                    v-on="on"
                    v-model="OilType"
                    :label="getItemName('オイルの詳細')[AnalizeTypeCategory+'label']"
                    :items="OilTypeList"
                    item-value="Value"
                    item-text="Text"
                    no-data-text="オイルの種類を選択してください。"
                    @change="changeOilType()"
                    @input="$v.OilType.$touch()"
                    @blur="$v.OilType.$touch()"
                    :error-messages="OilTypeErrors"
                    :error="$v.OilType.$error"
                    :messages="getItemName('オイルの詳細')[AnalizeTypeCategory+'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('オイルの詳細')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-select>
                </template>
                <span class="wrap-text">{{getItemName('オイルの詳細')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>

            <template v-if="isOtherOilType(OilType)">
              <v-col cols="10" xl="3" lg="3" md='3' sm='10' xs="10" dense >
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="OilTypeText"
                    :label="getItemName('オイルの詳細（その他）')[AnalizeTypeCategory+'label']"
                    :counter="getItemName('オイルの詳細（その他）')[AnalizeTypeCategory+'counter']"
                    @input="$v.OilTypeText.$touch()"
                    @blur="$v.OilTypeText.$touch()"
                    :error-messages="OilTypeTextErrors"
                    :messages="getItemName('オイルの詳細（その他）')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('オイルの詳細（その他）')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span class="wrap-text">{{getItemName('オイルの詳細（その他）')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
              </v-col>
            </template>
            <v-col cols="1" lg="1" md='1' sm='2' xs="2" align-self="center" dense>
              <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
            </v-col>

            <template v-if="hasOilProperties">
              <v-col cols="10" xl="2" lg="3" md='3' sm='10' xs="10" dense>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-select
                      v-on="on"
                      v-model="OilProperty"
                      :label="getItemName('オイルの性質')[AnalizeTypeCategory+'label']"
                      :items="OilPropertyList"
                      item-value="Value"
                      item-text="Text"
                      @input="$v.OilProperty.$touch()"
                      @blur="$v.OilProperty.$touch()"
                      :error-messages="OilPropertyErrors"
                      :messages="getItemName('オイルの性質')[AnalizeTypeCategory + 'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('オイルの性質')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-select>
                  </template>
                  <span class="wrap-text">{{getItemName('オイルの性質')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="1" lg="1" md='1' sm='2' xs="2" align-self="center" dense>
                <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>
              </v-col>
            </template>

            <v-col cols="11" lg="11" md="11" class="px-md-6 pa-2">
              <v-card v-if="getNoticeType==1" flat outlined class="pa-3">
                <div class="mb-2">
                  <v-icon class="mr-1" color="red">mdi-information</v-icon>
                  <span class="red--text vertical-align-middle">このオイルの分析・診断サービスのご利用は、事前にジャパン・アナリストにご相談ください。</span>
                </div>
                <div class="subtitle-2 mb-2">
                  <span>お取り扱いに注意が必要なオイルのため、分析・診断サービスのお申込みの前にジャパン・アナリストに注意事項などを確認してください。<br></span>
                  <span>オイルの成分、性質によっては分析・診断サービスをご利用頂けない場合ごございます。ご了承ください。<br></span>
                  <br>
                  <span>オイルに含まれる危険物の情報などを記入してください</span>
                  <v-chip class="ma-2" color="red" text-color="white" x-small dense>必須</v-chip>
                </div>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-textarea
                      v-on="on"
                      v-model="HazardousMaterialsDetail"
                      :label="getItemName('危険物の内容')[AnalizeTypeCategory+'label']"
                      filled
                      @input="$v.HazardousMaterialsDetail.$touch()"
                      @blur="$v.HazardousMaterialsDetail.$touch()"
                      :error-messages="HazardousMaterialsDetailErrors"
                      :messages="getItemName('危険物の内容')[AnalizeTypeCategory+'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('危険物の内容')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-textarea>
                  </template>
                  <span class="wrap-text">{{getItemName('危険物の内容')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-card>

              <v-card v-if="getNoticeType==2" flat outlined class="pa-3">
                <div class="mb-2">
                  <v-icon class="mr-1" color="red">mdi-information</v-icon>
                  <span class="red--text">このオイルの分析・診断サービスのご利用は、ジャパン・アナリストにご相談ください。</span>
                </div>
                <div class="subtitle-2 mb-2">
                  <span>お取り扱いに注意が必要なオイルのため、分析・診断サービスの利用は個別にご相談頂いております。<br></span>
                  <br>
                  <span>オイルに含まれる危険物の情報などを記入してください</span>
                  <v-chip class="ma-2" color="red" text-color="white" x-small dense>必須</v-chip>
                </div>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-textarea
                      v-on="on"
                      v-model="HazardousMaterialsDetail"
                      :label="getItemName('危険物の内容')[AnalizeTypeCategory+'label']"
                      filled
                      @input="$v.HazardousMaterialsDetail.$touch()"
                      @blur="$v.HazardousMaterialsDetail.$touch()"
                      :error-messages="HazardousMaterialsDetailErrors"
                      :messages="getItemName('危険物の内容')[AnalizeTypeCategory+'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('危険物の内容')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-textarea>
                  </template>
                  <span class="wrap-text">{{getItemName('危険物の内容')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-card>

              <v-card v-if="getNoticeType==4" flat outlined class="pa-3">
                <div class="mb-2">
                  <v-icon class="mr-1" color="red">mdi-information</v-icon>
                  <span class="red--text">このオイルの分析・診断サービスのご利用は、ジャパン・アナリストにご相談ください。</span>
                </div>
                <div class="subtitle-2 mb-2">
                  <span>このオイルの分析は個別にご相談を承ります。<br></span>
                  <span>ジャパン・アナリストにご連絡ください。<br></span>
                  <br>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="10" xl="3" lg="3" md='3' sm='10' xs="10" dense>
              <v-text-field
                v-model="OilmakerID"
                :label="getItemName('使用オイルメーカー')[AnalizeTypeCategory+'label']"
                counter=20
                @input="$v.OilmakerID.$touch()"
                @blur="$v.OilmakerID.$touch()"
                :error-messages="OilmakerIDErrors"
                :messages="getItemName('使用オイルメーカー')[AnalizeTypeCategory+'message']"
              >
                <template v-slot:prepend-inner v-if="getItemName('使用オイルメーカー')[AnalizeTypeCategory+'証明書']">
                  <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="1" lg="1" md='1' sm='2' xs="2" dense>
            </v-col>

            <v-col cols="10" xl="3" lg="3" md='3' sm='10' xs="10" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="OilModelNumber"
                    :label="getItemName('使用オイル銘柄')[AnalizeTypeCategory+'label']"
                    :counter="getItemName('使用オイル銘柄')[AnalizeTypeCategory + 'counter']"
                    @input="$v.OilModelNumber.$touch()"
                    @blur="$v.OilModelNumber.$touch()"
                    :error-messages="OilModelNumberErrors"
                    :messages="getItemName('使用オイル銘柄')[AnalizeTypeCategory+'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('使用オイル銘柄')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span class="wrap-text">{{getItemName('使用オイル銘柄')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="1" lg="1" md='1' sm='2' xs="2" align-self="center" dense>
              <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
            </v-col>
          </v-row>

            <v-row dense>
              <v-col cols="6" xl="2" lg="3" md='4' sm='5' xs="6" class="align-end" dense>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-select
                      v-on="on"
                      v-model="OilCondition"
                      :label="getItemName('オイルの状態')[AnalizeTypeCategory+'label']"
                      :items="OilConditionList"
                      item-value="Value"
                      item-text="Text"
                      clearable
                      @change="changeOilCondition"
                      :messages="getItemName('オイルの状態')[AnalizeTypeCategory+'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('オイルの状態')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-select>
                  </template>
                  <span class="wrap-text">{{getItemName('オイルの状態')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-col>
            </v-row>

            <template v-if="AnalizeTypeCategory=='一般'">
              <v-row dense>
                <v-col cols="6" xl="2" lg="3" md='4' sm='5' xs="6" class="align-end" dense>
                  <v-tooltip top color="grey darken-2">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        v-model="OilChange"
                        :label="getItemName('オイル交換量')[AnalizeTypeCategory+'label']"
                        @input="$v.OilChange.$touch()"
                        :error-messages="OilChangeErrors"
                        :messages="getItemName('オイル交換量')[AnalizeTypeCategory + 'message']"
                      >
                        <template v-slot:prepend-inner v-if="getItemName('オイル交換量')[AnalizeTypeCategory+'証明書']">
                          <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <span class="wrap-text">{{getItemName('オイル交換量')[AnalizeTypeCategory+'description']}}</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="3" xl="1" lg="2" md='2' sm='2' xs="2" dense>
                  <v-select
                    v-model="OilChangeUnit"
                    label="単位"
                    :items="liquidUnits"
                    item-value="Value"
                    item-text="Text"
                    clearable
                    @change="changeOilChangeUnit()"
                  ></v-select>
                </v-col>
                <v-col cols="1"  lg="1" md='1' sm='2' xs="2" dense>
                </v-col>
              </v-row>
            </template>


            <template v-if="AnalizeTypeCategory=='航空機'">
              <v-row dense>
                <v-col cols="12" lg="12" md="12" dense class="pa-0">
                    <v-checkbox
                      v-model="isOilChanged"
                      class="agree-text" 
                      dense
                      label="オイル交換情報を報告書に印字する"
                    ></v-checkbox> 

                    <template v-if="isOilChanged">
                      <v-row dense class="ml-6 mt-0">

                        <v-col cols="6" xl="2" lg="3" md='4' sm='5' xs="6" class="align-end" dense>
                          <v-menu
                            v-model="oilChangeDatePicker"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            bottom
                            :offset-y=true
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="OilChangeDate"
                                :label="getItemName('オイル交換日')[AnalizeTypeCategory+'label']"
                                v-bind="attrs"
                                v-on="on"
                                clearable
                                class="mb-3"
                                :messages="getItemName('オイル交換日')[AnalizeTypeCategory + 'message']"
                              >
                                <template v-slot:prepend-inner v-if="getItemName('オイル交換日')[AnalizeTypeCategory+'証明書']">
                                  <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                                </template>
                              </v-text-field>
                            </template>
                            <v-date-picker
                              v-model="OilChangeDate"
                              @input="oilChangeDatePicker = false"
                              locale="ja"
                            >
                              <span class="px-2 grey darken-2 white--text caption wrap-text">{{getItemName('オイル交換日')[AnalizeTypeCategory+'description']}}</span>
                            </v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="6" xl="2" lg="3" md='4' sm='5' xs="6" class="align-end" dense>
                          <v-tooltip top color="grey darken-2">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-on="on"
                                v-model="OilChange"
                                :label="getItemName('オイル交換量')[AnalizeTypeCategory+'label']"
                                class="ml-3 mb-3"
                                @input="$v.OilChange.$touch()"
                                :error-messages="OilChangeErrors"
                                :messages="getItemName('オイル交換量')[AnalizeTypeCategory + 'message']"
                              >
                                <template v-slot:prepend-inner v-if="getItemName('オイル交換量')[AnalizeTypeCategory+'証明書']">
                                  <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                                </template>
                              </v-text-field>
                            </template>
                            <span class="wrap-text">{{getItemName('オイル交換量')[AnalizeTypeCategory+'description']}}</span>
                          </v-tooltip>
                        </v-col>
                        <v-col cols="3" xl="1" lg="1" md='2' sm='2' xs="2" dense>
                          <v-select
                            v-model="OilChangeUnit"
                            label="単位"
                            :items="liquidUnits"
                            item-value="Value"
                            item-text="Text"
                            clearable
                            @change="changeOilChangeUnit()"
                          ></v-select>
                        </v-col>
                        <v-col cols="1"  lg="1" md='1' sm='2' xs="2" dense>
                        </v-col>
                      </v-row>
                    </template>
                  </v-col>
              </v-row>
            </template>

            <v-row dense>
              <v-col cols="6" xl="2" lg="3" md='4' sm='5' xs="6" class="align-end" dense>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="OilUsageTime"
                      :label="getItemName('オイル使用時間')[AnalizeTypeCategory+'label']"
                      @input="$v.OilUsageTime.$touch()"
                      :error-messages="OilUsageTimeErrors"
                      :messages="getItemName('オイル使用時間')[AnalizeTypeCategory+'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('オイル使用時間')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                <span class="wrap-text">{{getItemName('オイル使用時間')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="4" xl="1" lg="2" md='2' sm='4' xs="4" dense>
                <template v-if="AnalizeTypeCategory=='一般'">
                  <v-select
                    v-model="OilUsageTimeUnit"
                    label="単位"
                    :items="useUnits"
                    item-value="Value"
                    item-text="Text"
                    clearable
                    @change="changeOilUsageTimeUnit()"
                  ></v-select>
                </template>
              </v-col>
              <v-col cols="1"  lg="1" md='1' sm='2' xs="2" dense>
              </v-col>
              <v-col cols="5" md="3" class="align-end" dense> 
              </v-col>
            </v-row>

<!--

          <template v-if="AnalizeTypeCategory=='航空機'">

            <v-row dense>
              <v-col cols=12 dense>
                <v-checkbox
                  v-model="UseFilter"
                  label="オイルフィルター情報を報告書に印字する"
                  class="caption my-0 py-0"
                  dense
                ></v-checkbox>
              </v-col>
            </v-row>

            <v-row dense class="ml-6" v-if="UseFilter">
              <v-col cols="4" xl="2" lg="2" md='3' sm='3' xs="3" dense>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="FilterUsageTime"
                      :label="getItemName('フィルター使用時間')[AnalizeTypeCategory+'label']"
                      dense
                      @input="$v.FilterUsageTime.$touch()"
                      :error-messages="FilterUsageTimeErrors"
                      :messages="getItemName('フィルター使用時間')[AnalizeTypeCategory + 'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('フィルター使用時間')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <span>フィルター交換後のフィルター使用時間を入力します。</span>
                </v-tooltip>
              </v-col>

              <v-col cols="4" xl="1" lg="1" md='2' sm='3' xs="2" dense>
                <v-select
                  v-model="FilterUsageTimeUnit"
                  label="単位"
                  dense
                  :items="useUnits"
                  item-value="Value"
                  item-text="Text"
                  clearable
                  @change="changeFilterUsageTimeUnit()"
                ></v-select>
              </v-col>
              <v-col cols="1"  lg="1" md='1' sm='2' xs="2" dense>
              </v-col>
              <v-col cols="5" md="3" class="align-end" dense> 
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="4" xl="2" lg="2" md='3' sm='3' xs="3" dense>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="SamplingPlace"
                      :label="getItemName('サンプル採取場所')[AnalizeTypeCategory+'label']"
                      :counter="getItemName('サンプル採取場所')[AnalizeTypeCategory+'counter']"
                      @input="$v.SamplingPlace.$touch()"
                      :error-messages="SamplingPlaceErrors"
                     :messages="getItemName('サンプル採取場所')[AnalizeTypeCategory + 'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('サンプル採取場所')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <span>分析依頼時に主にサンプル（オイル）を採油する場所（TOKYO、OSAKAなど）を入力してください</span>
                </v-tooltip>
              </v-col>
              <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" dense>
              </v-col>
            </v-row>
          </template>
-->

          <v-btn color="primary" class="mt-4" @click="changeStepper(2)" outlined>次へ</v-btn>
        </v-card>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > 2" step="2" @click="changeStepper(2)" color="teal darken-1">
        分析・診断依頼内容の入力
      </v-stepper-step>
      <v-stepper-content step="2" >
        <v-card class="mt-3" flat>
          <v-row dense>               
            <v-col cols="10" md="5" densa>
              <v-tooltip top color="grey darken-3">
                <template v-slot:activator="{ on }">
                  <v-autocomplete
                    v-on="on"
                    v-model="AnalizeTypeGroup"
                    @change="changeAnalizeTypeGroup"
                    :label="getItemName('分析方法')[AnalizeTypeCategory+'label']"
                    dense
                    :items="analizeTypeGroupList"
                    item-value="Value"
                    item-text="Text"
                    :error-messages="AnalizeTypeGroupErrors"
                    :error="$v.AnalizeTypeGroup.$error"
                    :messages="getItemName('分析方法')[AnalizeTypeCategory + 'message']"
                  >
                  </v-autocomplete>
                </template>
                <span>
                分析方法を「社定法」か「公定法」かで選択してください。<br><br>
                <strong>社定法とは...</strong><br>
                弊社の独自法です。安価で短納期です。<br><br>
                <strong>公定法とは...</strong><br>
                公的規格に準拠した方法です。<br>
                ご依頼時に条件がありますので、事前に営業部へご連絡下さい。<br>
                ※分析方法で公定法を選択し、公定法分析項目を選択された場合は、上記注意事項に沿ってご依頼ください。
                </span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" md='1' align-self="center" dense>
              <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
            </v-col>

            <v-col cols="10" md="5" densa>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-select
                    v-on="on"
                    v-model="AnalizeType"
                    label="分析区分"
                    :items="analizeTypeList"
                    item-value="Value"
                    item-text="Text"
                    no-data-text="分析方法を選択してください。"                    
                    @change="changeAnalizeType"
                    readonly
                    dense
                  >
                  </v-select>
                </template>
                <span class="wrap-text">{{getItemName('分析区分')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" md='1' align-self="center" dense>
              <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
            </v-col>

            <v-col cols="12" md="5" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-autocomplete
                    v-on="on"
                    clearable
                    v-model="AnalizeSet" 
                    :label="getItemName('セット分析')[AnalizeTypeCategory+'label']"
                    dense 
                    :items="analizeSetList"  
                    item-value="Value" 
                    item-text="Text" 
                    @change="changeAnalizeSet" 
                    no-data-text="この分析区分にはセット分析はありません"
                    @input="$v.AnalizeSet.$touch()"
                    :error-messages="AnalizeSetErrors"
                    :error="$v.AnalizeSet.$error"
                    :message="getItemName('セット分析')[AnalizeTypeCategory+'message']"
                  >
                    <template v-slot:item="{ item }">
                      <v-checkbox
                      :input-value="AnalizeSet == item.Value"
                      />
                      <v-list-item-content>
                        <v-list-item-title v-text="item.Text"></v-list-item-title>
                        <v-list-item-subtitle v-html="item.Description" class="wrap-text"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </template>
                <span class="wrap-text">{{getItemName('セット分析')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>

            <v-col cols="12" md="11" v-show="isSelectAnalizeSet" dense>
              <v-select
                v-model="analizeSetItems"
                :items="analizeSetItems"
                item-value="Value"
                item-text="Text"
                label="セットに含まれる分析項目"
                multiple
                disabled
                append-icon=""
              >
                <template v-slot:selection="{ item }">
                  <v-chip>
                    <span>{{ item.Text }}</span>
                  </v-chip>
                </template>
              </v-select>
            </v-col>
            
            <v-col cols="12" md="11" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-autocomplete
                    v-on="on"
                    v-model="AnalizeItems"
                    clearable
                    :items="activeAnalizeItemList"
                    item-value="Value"
                    item-text="Text"
                    :label="getItemName('個別分析項目')[AnalizeTypeCategory+'label']"
                    multiple
                    chips
                    no-data-text="分析区分を選択してください。"
                    @change="changeAnalizeItems"
                    @input="$v.AnalizeItems.$touch()"
                    :error-messages="AnalizeItemsErrors"
                    :error="$v.AnalizeItems.$error"
                    :messages="getItemName('個別分析項目')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip
                        color="green darken-3"
                        text-color="white"
                      >
                        <span>{{ item.Text }}</span>
                      </v-chip>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-checkbox
                      :input-value="AnalizeItems.includes(item.Value)"
                      />
                      <v-list-item-content>
                        <v-list-item-title v-text="item.Text"></v-list-item-title>
                        <v-list-item-subtitle v-html="item.Description" class="wrap-text"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </template>
                <span class="wrap-text">{{getItemName('個別分析項目')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
          </v-row>


          <template v-for="parent of Object.keys(AnalizeItemSub)">
            <v-row dense class="ml-2" v-bind:key="parent">
              <v-col cols=12 dense class="mb-0 pb-0">
                <v-icon color="blue">mdi-information</v-icon>
                <span class="font-weight-bold">「{{getAnalizeItemName(parent)}}」</span>が選択されました。以下の分析を追加することができます。
              </v-col>
              <v-col cols=12 dense class="ml-6 mb-0 pb-0">
                  <v-autocomplete
                    v-model="AnalizeItemSub[parent]" 
                    :items="analizeItemSubList[parent]" 
                    item-value="Value" 
                    item-text="Text" 
                    label="追加項目"
                    class="mb-0 pb-0"
                    @change="changeAnalizeItemSub"
                    :error-messages="AnalizeItemSubError[parent]"
                    multiple
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip
                        color="green darken-1"
                        text-color="white"
                      >
                        <span>{{ item.Text }}</span>
                      </v-chip>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-checkbox
                      :input-value="AnalizeItemSub[parent].includes(item.Value)"
                      />
                      <v-list-item-content>
                        <v-list-item-title v-text="item.Text"></v-list-item-title>
                        <v-list-item-subtitle v-html="item.Description" class="wrap-text"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
              </v-col>
            </v-row>
          </template>

          <v-row dense>
            <v-col cols="12" md="6" dense>
              <v-card flat>
                <v-radio-group v-model="Filter" class="ml-md-8 ml-2 pa-2" id="card-subject" @change="changeFilter" >
                  <template v-slot:label>
                    <v-tooltip top color="grey darken-2">
                      <template v-slot:activator="{ on }">
                        <div v-on="on">汚染度（質量法）試験後の<strong>フィルター返却</strong></div>
                      </template>
                      <span class="wrap-text">{{getItemName('フィルター返却')[AnalizeTypeCategory+'description']}}</span>
                    </v-tooltip>
                  </template>
                  <v-radio value="001">
                    <template v-slot:label>
                      <div id="card-subject">不要（0円）</div>
                    </template>
                  </v-radio>
                  <v-radio value="002">
                    <template v-slot:label>
                      <div id="card-subject">必要。<span  id="card-subject2">ラミネート加工 <strong class="black--text">あり（1,700円／検体）</strong></span></div>
                    </template>
                  </v-radio>
                  <v-radio value="003">
                    <template v-slot:label>
                      <div id="card-subject">必要。<span  id="card-subject2">ラミネート加工 <strong class="black--text">なし（600円／検体）</strong></span></div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-card>
            </v-col>

            <v-col cols="12" md="6" dense>
              <v-card flat>
                <v-radio-group v-model="Surplus" class="ml-md-8 ml-2 pa-2">
                  <template v-slot:label>
                    <v-tooltip top color="grey darken-2">
                      <template v-slot:activator="{ on }">
                        <div v-on="on"><strong>着払いで</strong>サンプルの返却</div>
                      </template>
                      <span class="wrap-text">{{getItemName('サンプル返却')[AnalizeTypeCategory+'description']}}</span>
                    </v-tooltip>
                  </template>
                  <v-radio value="0">
                    <template v-slot:label>
                      <div id="card-subject">返却を希望 しない</div>
                    </template>
                  </v-radio>
                  <v-radio value="1">
                    <template v-slot:label>
                      <div id="card-subject">返却を希望 <span  id="card-subject2">（返送には別途手数料が掛ります）</span></div>
                    </template>
                  </v-radio>
                </v-radio-group>
                <br>
              </v-card>
            </v-col>
          </v-row>


          <v-row v-show="standardValueList.length" dense class="mx-5 pt-0">
            <v-col cols="12" lg="3" md='12' sm='12' xs="12" class="align-start t mt-0 pt-0" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-switch
                    v-on="on"
                    class="ml-3"
                    v-model="isSwStandard"
                    label="報告書へ分析規格を記載"
                    @change="changeSwStandard"
                  >
                  </v-switch>
                </template>
                <span>分析・診断報告書に分析規格の記載をご希望される場合はチェックしてください。</span>
              </v-tooltip>
            </v-col>

            <v-col cols="12" lg="9" md='12' sm='12' xs="12" class="align-start"  v-show="standardValueList.length&&isSwStandard">
              <v-card flat outlined>
                <v-row class="px-4 pt-4" dense>
                  <v-col cols="8">
                    <div>
                      <v-icon color="blue">mdi-information-outline</v-icon>
                      <span class="caption">
                        ジャパン・アナリストで登録済みの分析規格の一覧から選択してください<br>
                        分析規格の追加をご希望の場合は、弊社担当営業までご連絡ください。
                      </span>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="px-6" dense>
                  <v-col cols="10">
                    <v-tooltip top color="grey darken-2">
                      <template v-slot:activator="{ on }">
                        <v-select
                          v-on="on"
                          v-model="StandardValue" 
                          clearable 
                          @change="changeStandardValue" 
                          label="分析規格" 
                          dense 
                          :items="standardValueList" 
                          item-value="Value" 
                          item-text="Text" 
                          no-data-text="この分析区分には分析規格はありません"
                          @input="$v.StandardValue.$touch()"
                            :error-messages="StandardValueErrors"
                            :error="$v.StandardValue.$error"
                        >
                          <template slot='selection' slot-scope='data'>
                            {{ data.item.Text }} [ {{ data.item.StandardValue }} ]
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ data.item.Text }} [ {{ data.item.StandardValue }} ]
                          </template>
                        </v-select>
                      </template>
                      <span>ご希望の分析規格を選択してください。</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="2" align-self="center">
                    <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>

          <v-btn color="primary" class="mb-3" @click="changeStepper(3)" outlined>次へ</v-btn>

          <v-row dense>
            <v-col cols="12" lg="3" md="5" dense >
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                    <div v-on="on" class="body-1">
                      分析に必要なサンプル量
                    </div>
                </template>
                <span class="wrap-text">{{getItemName('必要オイル量')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
              <div class="title ml-2">
                {{Require.toLocaleString()}} mL
              </div>
            </v-col>
            <v-col cols="12" lg="3" md="5" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <div class="body-1" v-on="on">
                    分析料金
                  </div>
                </template>
                <span class="wrap-text">{{getItemName('分析料金')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
              <div class="title ml-2">
                {{analizeFee.toLocaleString()}} 円<span class="body-1">（税抜き）</span>
              </div>
            </v-col>
          </v-row>
          <v-overlay absolute :value="overlayStepper1" opacity="0.8" color="white">
            <v-progress-circular indeterminate size="64" color="amber"></v-progress-circular>
          </v-overlay>
        </v-card>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > 3" step="3" @click="changeStepper(3)" color="teal darken-1">
        サンプル情報の入力
      </v-stepper-step>
      <v-stepper-content step="3" >
        <v-card flat>
          <v-row dense>
            <v-col cols="12" lg="3" md="5" dense >
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                    <div v-on="on" class="body-1">
                      分析に必要なサンプル量
                    </div>
                </template>
                <span class="wrap-text">{{getItemName('必要オイル量')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
              <div class="title ml-2">
                {{Require.toLocaleString()}} mL
              </div>
            </v-col>
            <v-col cols="12" lg="3" md="5" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <div class="body-1" v-on="on">
                    分析料金
                  </div>
                </template>
                <span class="wrap-text">{{getItemName('分析料金')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
              <div class="title ml-2">
                {{analizeFee.toLocaleString()}} 円<span class="body-1">（税抜き）</span>
              </div>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="10" lg="8" md="10" sm='10' xs="10" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="SampleName"
                    :label="getItemName('サンプル名')[AnalizeTypeCategory+'label']"
                    :counter="getItemName('サンプル名')[AnalizeTypeCategory+'counter']"
                    dense
                    @input="$v.SampleName.$touch()"
                    :error-messages="SampleNameErrors"
                    :messages="getItemName('サンプル名')[AnalizeTypeCategory+'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('サンプル名')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span class="wrap-text">{{getItemName('サンプル名')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" lg="1" md='1' sm='1' xs="2" align-self="center" dense>
              <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="8" lg="2" md="3" sm='4' xs="8" dense>
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="SamplingAt"
                    :label="getItemName('採取日')[AnalizeTypeCategory+'label']"
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    @input="$v.SamplingAt.$touch()"
                    :error-messages="SamplingAtErrors"
                    :messages="getItemName('採取日')[AnalizeTypeCategory+'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('採取日')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="SamplingAt"
                  @input="menu2 = false"
                  locale="ja"
                ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="2" lg="1" md='1' sm='1' xs="2" align-self="center" dense>
            </v-col>

            <v-col cols="8" lg="2" md="3" sm='4' xs="8" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="BottleCount"
                    :label="getItemName('ボトル数')[AnalizeTypeCategory+'label']"
                    @input="$v.BottleCount.$touch()"
                    :error-messages="BottleCountErrors"
                    :messages="getItemName('ボトル数')[AnalizeTypeCategory+'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('ボトル数')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span class="wrap-text">{{getItemName('ボトル数')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" lg="1" md='1' sm='1' xs="2" align-self="center" dense>
              <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
            </v-col>
          </v-row>

          <template v-if="AnalizeTypeCategory=='航空機'">
            <v-row dense>
              <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="SamplingBy"
                      :label="getItemName('採取者')[AnalizeTypeCategory+'label']"
                      :counter="getItemName('採取者')[AnalizeTypeCategory+'counter']"
                      @input="$v.SamplingBy.$touch()"
                      :error-messages="SamplingByErrors"
                      :messages="getItemName('採取者')[AnalizeTypeCategory+'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('採取者')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <span class="wrap-text">{{getItemName('採取者')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="2" xl="1" lg="1" md='1' sm='1' xs="2" align-self="center" dense>
              </v-col>

              <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="SamplingPlace"
                      :label="getItemName('サンプル採取場所')[AnalizeTypeCategory+'label']"
                      counter=12
                      @input="$v.SamplingPlace.$touch()"
                      :error-messages="SamplingPlaceErrors"
                      :messages="getItemName('サンプル採取場所')[AnalizeTypeCategory+'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('サンプル採取場所')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <span class="wrap-text">{{getItemName('サンプル採取場所')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-col>

            </v-row>
          </template>

          <v-row dense>
            <v-col cols="12" lg="12" md="12" dense>
              <span class="caption">{{getItemName('サンプルメモ')[AnalizeTypeCategory+'label']}}（{{getItemName('サンプルメモ')[AnalizeTypeCategory+'message']}}）</span>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-textarea v-model="SampleMemo"
                    v-on="on"
                    dense
                    filled
                    counter=60
                    @input="$v.SampleMemo.$touch()"
                    :error-messages="SampleMemoErrors"
                  ></v-textarea>
                </template>
                <span class="wrap-text">{{getItemName('サンプルメモ')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
          </v-row>

<!--
          <v-row dense>
            <v-col cols="12" lg="12" md="12" dense>
              <span class="caption">{{getItemName('分析目的')[AnalizeTypeCategory+'label']}}</span>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                <v-textarea
                    v-on="on"
                    v-model="AnalizePurpose"
                    filled
                    counter=256
                    :messages="getItemName('分析目的')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('分析目的')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                </v-textarea>
                </template>
                <span class="wrap-text">{{getItemName('分析目的')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
          </v-row>
-->


          <v-btn color="primary" @click="changeStepper(4)" outlined>次へ</v-btn>
        </v-card>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > 4" step="4" @click="changeStepper(4)" color="teal darken-1">
        サンプル情報の{{ samplingmode }}
      </v-stepper-step>
      <v-stepper-content step="4" >
        <v-card flat>
          <v-row dense>
            <v-col cols="12" lg="12" md='12' sm='12' xs="12">
              <v-card flat outlined class="pa-3">
                <div class="subtitle-2 mb-2">
                  <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
                  <span class="primary--text">分析・診断サービスのご依頼はまだ完了しません。</span>
                </div>
                <p class="caption">
                  分析サンプルが{{ samplingmode }}されます。<br>
                  全てのサンプル情報を{{ samplingmode }}したら、トップ画面から「分析・診断サービスに依頼する」を行ってください。<br>
                </p>
              </v-card>
            </v-col>
          </v-row>
          
          <v-row v-if="isHazardousMaterials==1" dense>
            <v-col cols="12" lg="12" md="12" densa class="px-md-6 pa-2">
              <v-card  flat outlined class="ma-5 pa-3">
                <div class="mb-2">
                  <v-icon class="mr-1" color="red" x-large>mdi-information</v-icon>
                  <span class="display red--text vertical-align-middle">危険物が含まれる分析サンプルのご依頼には事前確認が必要です。</span>
                </div>
                <div class="subtitle-2 mb-2">
                  <span>危険物が含まれるオイルの分析には、必要資料のご提出など事前にご確認頂いただきたい項目がございます。<br></span>
                  <span>お手数おかけしますが、分析・診断サービスの利用について担当営業か、以下よりお問合せ／ご確認をお願いいたします。</span>
                </div>
                <v-btn rounded color="body-2 amber darken-1 font-weight-bold"  @click="openInquiry()" class="mx-2 mb-5">
                  <v-icon class="mr-2">mdi-comment-question-outline  </v-icon>ご連絡・お問合わせ
                </v-btn>
                <div class="subtitle-2 mb-2">
                  <v-icon class="mr-1">mdi-information-outline</v-icon>
                  <span>注意事項などご確認頂きましたのち、下記をチェックしてください。<br></span>
                </div>
                <div class="subtitle-2 mb-2">
                  <span class="red--text">下記のチェックがされていない分析サンプルは、分析・診断サービスの依頼をお受けすることができません。</span>
                </div>
                <v-card flat class="pa-3">
                  <v-checkbox
                    v-model="HazardousMaterialsConfirmed"
                    class="agree-text" 
                    label="危険物を含む分析サンプルについて、ジャパン・アナリストに確認しました。"
                    dense
                  ></v-checkbox>
                  <v-tooltip top color="grey darken-2">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        v-model="TrackingNumber"
                        label="お問い合わせ番号"
                        dense
                      ></v-text-field>
                    </template>
                    <span>危険物に関するお問合せの番号を入力します</span>
                  </v-tooltip>
                </v-card>
              </v-card>
            </v-col>
          </v-row>
        </v-card>

        <v-row
        >
          <v-col cols="6">
            <v-spacer></v-spacer>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    rounded
                    color="amber darken-1"
                    @click="confirmCreateMachine"
                    data-addSampleTemp
                  >
                    <v-icon>mdi-checkbox-marked-circle</v-icon>分析サンプルを{{ samplingmode }}
                  </v-btn>
                </template>
                <span>分析・診断サービスに依頼するサンプル情報を{{ samplingmode }}します。</span>
              </v-tooltip>
            <v-spacer></v-spacer>
          </v-col>

          <v-col cols="6" class="text-lg-right" v-if ="!isCreate">
            <v-tooltip top color="grey"  >
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" slot="activator" rounded color="red white--text" @click="showDialog()" dark data-delMachine>
                <v-icon class="mr-2">mdi-delete-circle</v-icon>
                この分析サンプルを削除
                </v-btn>
              </template>
              <span>この分析サンプルを削除します</span>
            </v-tooltip>

          </v-col>

        </v-row>
      </v-stepper-content>
      </v-stepper>
    </v-form>

<!-- 確認ダイアログ -->
    <v-dialog
      v-model="isConfirmed"
      persistent
      max-width="90%"
    >
      <v-card class="px-3 py-2">
        <v-card-title class="headline" id="card-title">
          <v-icon class="mr-1" color="primary" large>mdi-information-outline</v-icon>
          {{ samplingmode }}内容をご確認ください
        </v-card-title>
        <v-card-text>
          下記の{{ samplingmode }}内容をご確認のうえ、「分析サンプルを{{ samplingmode }}する」ボタンをクリックしてください</v-card-text>
        
        <v-card outlined flat class="mb-3">
          <div class="teal darken-1 pa-2 mb-1 white--text">オイル情報</div>
          <v-row dense class="pa-2">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイルの種類')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイルの種類')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilTypeCategoryText}}／{{OilTypeText}} {{OilPropertyText}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('使用オイル')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('使用オイル')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilmakerText}}／{{OilModelNumber}} {{OilGradeText}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイルの状態')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイルの状態')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilConditionText}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル交換日')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル交換日')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilChangeDate}}
                    <template v-if="!OilChangeDate">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル交換量')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル交換量')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilChange}} {{OilChangeUnitText}}
                    <template v-if="!OilChange">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル使用時間')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル使用時間')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilUsageTime}} {{OilUsageTimeUnitText}}
                    <template v-if="!OilUsageTime">-</template>
                  </div>
                </v-col>

          </v-row>

          <div class="teal darken-1 pa-2 mb-1 white--text">分析・診断内容
          </div>
          <v-row dense class="pa-2">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析方法')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析方法')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{AnalizeTypeGroup}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析区分')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析区分')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{AnalizeTypeName}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('セット分析')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('セット分析')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{AnalizeSetName}}
                    <template v-if="!AnalizeSetName">-</template>
                  </div>
                </v-col>
<!--
                <v-col cols="12" v-show="isSelectAnalizeSet">
                  <v-select
                    v-model="analizeSetItems"
                    :items="analizeSetItems"
                    item-value="Value"
                    item-text="Text"
                    label="セットに含まれる分析項目"
                    multiple
                    disabled
                    append-icon=""
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip>
                        <span>{{ item.Text }}</span>
                      </v-chip>
                    </template>
                  </v-select>
                </v-col>
-->

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('セット分析項目')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('セット分析項目')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pt-0">
                  <template v-for="(item, index) in analizeSetItems">
                    <v-chip small color="gray" class="white--black ml-2 mb-1" :key="index"> {{item.Text}}</v-chip>
                  </template>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('個別分析項目')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('個別分析項目')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pt-0">
                  <template v-for="(item, index) in analizeItemNames">
                    <v-chip small color="green" class="white--text ml-2 mb-1" :key="index"> {{item}}</v-chip>
                  </template>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('フィルター返却')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('フィルター返却')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    <template v-if="Filter=='001'" class="body-1">不要：0円</template>
                    <template v-if="Filter=='002'" class="body-1">必要（ラミネート加工あり）:1,700円/検体</template>
                    <template v-if="Filter=='003'" class="body-1">必要（ラミネート加工なし）:600円/検体</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプル返却')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプル返却')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    <template v-if="Surplus=='0'">返却不要</template>
                    <template v-if="Surplus=='1'">返却必要（着払いで郵送）※別途サンプル返却手数料がかかります</template>
                  </div>
                </v-col>

          </v-row>

          <div class="teal darken-1 pa-2 mb-1 white--text">サンプル情報</div>
          <v-row dense class="pa-2">

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプル名')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプル名')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{SampleName}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('採取日')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('採取日')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{SamplingAt}} 
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('採取者')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('採取者')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{SamplingBy}} 
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプル採取場所')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプル採取場所')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{SamplingPlace}} 
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('ボトル数')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('ボトル数')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{BottleCount}} 本
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('必要オイル量')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('必要オイル量')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{Require.toLocaleString()}} mL
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析料金')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析料金')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{analizeFee.toLocaleString()}} 円
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプルメモ')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプルメモ')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{SampleMemo}} 
                  </div>
                </v-col>
<!--
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析目的')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析目的')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{AnalizePurpose}} 
                  </div>
                </v-col>
-->
          </v-row>

          <v-row dense class="pa-2">
            <v-col v-show="standardValueList.length" cols="6" md="3" dense >
              <v-chip label outlined class="label-chip" small>報告書へ規格の記載：</v-chip>
              <span v-if="isSwStandard">記載する</span>
              <span v-if="!isSwStandard">記載しない</span>
            </v-col>
            <v-col v-show="standardValueList.length" cols="6" md="3" dense>
              <v-text-field v-if="isSwStandard" v-model="StandardValueName" label="記載する分析規格" dense readonly></v-text-field>
            </v-col>

            <v-col cols="12" md="12" v-if="isHazardousMaterials==1" dense>
              <v-card flat class="pa-3">
                <v-checkbox
                  v-model="HazardousMaterialsConfirmed"
                  dense
                  readonly
                  class="agree-text" 
                  label="危険物を含む分析サンプルについて、ジャパン・アナリストに確認しました。"
                ></v-checkbox>
                <v-chip label outlined class="label-chip" small>お問い合わせ番号</v-chip>
                <span class="body-1">{{ TrackingNumber }}</span>
              </v-card>
            </v-col>
          
          </v-row>

        </v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip top color="grey darken-2">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                color="grey darken-4"
                outlined
                rounded
                elevation="2"
                @click="isConfirmed = false"
              >
              キャンセル
              </v-btn>
            </template>
            <span>サンプル情報を修正します</span>
          </v-tooltip>
          <v-tooltip top color="grey darken-2">
            <template v-slot:activator="{ on }">
              <v-btn
              v-on="on"
              rounded 
              color="amber darken-1" 
              @click="createSample()" 
              data-createApplication 
              class="px-2"
              >
                <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
                <span class="d-none d-sm-flex">分析サンプルを</span>
                {{ samplingmode }}
              </v-btn> 
            </template>
            <span>サンプル情報を{{ samplingmode }}します</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialogコール -->
  <app-dialog :failureUrl="failureUrl" ref="isFailured"></app-dialog>
  <suc-dialog :successText="successText" :successUrl="successUrl" ref="isSuccessed"></suc-dialog>
  <vali-dialog :valiErrorText="valiErrorText" ref="isErrored"></vali-dialog>
  <deleteSampleConfirm class="pa-0" :sampleid="sampleid" :Name="Name" ref="deletedialog"></deleteSampleConfirm>
  <samplingSuccessed :successText="successText" :successUrl="successUrl" :category="AnalizeTypeCategory" ref="isSamplingSuccessed"></samplingSuccessed>

  </v-container>
</template>

<script>
import { API, graphqlOperation} from "aws-amplify"
import { createSample } from "../graphql/mutations"
import { updateSample } from "../graphql/mutations"
import { numeric, required, maxLength } from 'vuelidate/lib/validators'
import validations from '../utils/validations.js'
import { getSample } from '../graphql/queries'
import isFailured from "../components/failureDialog.vue"
import valiErrored from "../components/validateErrorDialog.vue"
import entSuccessed from "../components/successDialog.vue"
import samplingSuccessed from "../components/successSamplingDialog.vue"
import generateUuid  from '../utils/generateUuid.js'
import deleteSampleConfirm from '../components/DeleteSampleConfirm'
import utilsMixin  from '../utils/mixin.js'
import utils  from '../utils/utils.js'

function isStandardValue (value, vm) {
  if (vm.isSwStandard) {
    if (value) {
      return true
    } else {
      return false
    }
  } else {
    return true
  }
}

function isAnalizeSet (value, vm) {
  console.log('value', value)
  if (!vm.AnalizeSet&&!vm.AnalizeItems.length) {
    return false
  } else {
    return true
  }
}

function hasOilChangeUnit (value, vm) {
  if (vm.OilChange) {
    if(!vm.OilChangeUnit) {
      return false
    }
  }
  return true
}
function hasOilUsageTimeUnit (value, vm) {
  if (vm.OilUsageTime) {
    if(!vm.OilUsageTimeUnit) {
      return false
    }
  }
  return true
}
function hasHazardousMaterialsDetail (vaslue, vm) {
  if (vm.isHazardousMaterials == "1") {
    if(!vm.HazardousMaterialsDetail) {
      return false
    }
  }
  return true

}

function requiredPromptFumei (value) {
  if (!value) {
    return false
  }
  return true
}

function requiredPromptFumeiEn (value) {
  if (!value) {
    return false
  }
  return true
}

function requiredOilProperty(value) {
  if(this.hasOilProperties && !value) {
    return false
  }
  return true
}

function float(value) {
  if(value) {
    let _value = String(value)
    if(!_value.match(/^([1-9]\d*|0)(\.\d{1,2})?$/)){
        return false;
    }
  }
  return true
}

function useTime(value) {
  if(value) {
    let _value = String(value)
    if(!_value.match(/^([1-9]\d*|0)(\.\d{1})?$/)){
      if(_value.match(/^([0-9]\d*):([0-5][0-9])$/)){
        return true;
      }else {
        return false;
      }
    }
  }
  return true
}

function alphaNumPlus(value) {
  if(value) {
    // 半角英数（＋ハイフン、ドット、アンダースコア）のみ許可
//  if(!value.match(/^[0-9a-zA-Z/.-]*$/)){
    if(!value.match(/^[0-9a-zA-Z/.\s_-]*$/)){
        return false;
    }
  }
  return true
}

function analizeItemRelations() {
/*
// 追加項目は必須でないためエラーなし
  console.log("analizeItemRelations:", this.$v.AnalizeItems)
  this.AnalizeItemSubError = {}
  for (var parentItem of Object.keys(this.AnalizeItemSub)) {
    if(this.AnalizeItemSub[parentItem].length==0) {
      this.AnalizeItemSubError[parentItem] = "追加する分析項目を選択してください"
      return false
    }
  }
*/
  return true
}
// (社)汚染度(計数法・SAE)Table1(PCSAE1) 関連チェック1
// (社)汚染度(計数法・SAE)Table2(PCSAE2) 関連チェック1
function analizeItemRelationPCSA1(value, vm) {
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("PCSA1M")) {
    return vm.AnalizeItems.includes("PCISOM") || vm.analizeSetItems.some(item => item.Value == "PCISOM")
  }

  if(vm.AnalizeItems.includes("PCSA2M")) {
    return vm.AnalizeItems.includes("PCISOM") || vm.analizeSetItems.some(item => item.Value == "PCISOM")
  }

  return true
}

// (社)汚染度(計数法・SAE)Table1(PCSAE1) 関連チェック2
// (社)汚染度(計数法・SAE)Table2(PCSAE2) 関連チェック2
function analizeItemRelationPCSA2(value, vm) {
  let condition1 = 0
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }

  condition1 += vm.AnalizeItems.includes("PCSA1M") ? 1 : 0
  condition1 += vm.AnalizeItems.includes("PCSA2M") ? 1 : 0
  if(condition1 >= 2) {
    return false
  }

  return true
}

// 粘度指数(VI__J) 関連チェック
function analizeItemRelationVI___J(value, vm) {
  console.log("analizeItemRelationVI___J:", vm.AnalizeItems)
  if(vm.AnalizeItems.includes("VI___J")) {
    let condition1 = 0
    condition1 += vm.AnalizeItems.includes("V40__J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("V100_J") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "V40__J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "V100_J").length > 0 ? 1 : 0

    if(condition1 >= 2) {
      return true
    }
    return false
  }
  return true
}

// ｾﾀﾝ指数(CETINJ) 関連チェック
function analizeItemRelationCETINJ(value, vm) {
  console.log("analizeItemRelationCETINJ:", vm.AnalizeItems)
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("CETINJ")) {
    let condition1 = 0
    condition1 += vm.AnalizeItems.includes("DIST_M") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("SG___J") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "DIST_M").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "SG___J").length > 0 ? 1 : 0

    if(condition1 >= 2) {
      return true
    }
    return false
  }
  return true
}

// 総発熱量（計算値）(GCVC_J) 関連チェック
function analizeItemRelationGCVC_J(value, vm) {
  console.log("analizeItemRelationGCVC_J:", vm.AnalizeItems)
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("GCVC_J")) {
    let condition1 = 0
    let condition2 = 0
    condition1 += vm.AnalizeItems.includes("KF2__M") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S4___M") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S2___J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("ASH__M") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("SG___J") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "KF2__M").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S4___M").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S2___J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "ASH__M").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "SG___J").length > 0 ? 1 : 0
    if(condition1 >= 3) {
      if(condition2 >= 1) {
        return true
      }
    }
    return false
  }
  return true
}

// 真発熱量（計算値）(NCVC_J)関連チェック
function analizeItemRelationNCVC_J(value, vm) {
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("NCVC_J")) {
    let condition1 = 0
    let condition2 = 0
    condition1 += vm.AnalizeItems.includes("KF2__M") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S4___M") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S2___J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("ASH__M") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("SG___J") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "KF2__M").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S4___M").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S2___J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "ASH__M").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "SG___J").length > 0 ? 1 : 0
    if(condition1 >= 3) {
      if(condition2 >= 1) {
        return true
      }
    }
    return false
  }
  return true
}

// 顕微鏡写真(PHO__X)関連チェック
function analizeItemRelationPHO__X(value, vm) {
  console.log("analizeItemRelationPHO__X:", vm.AnalizeItems)
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("PHO__X")) {
    let condition1 = 0
    
    condition1 += vm.AnalizeItems.includes("PW___M") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW01_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW10_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW45_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW80_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW12_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW50_X") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW___M").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW01_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW10_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW45_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW12_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW50_X").length > 0 ? 1 : 0
    if(condition1 >= 1) {
      return true
    }
    return false
  }
  return true
}

// 写真２枚(PHO2_X)関連チェック
function analizeItemRelationPHO2_X(value, vm) {
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("PHO2_X")) {
    let condition1 = 0
    
    condition1 += vm.AnalizeItems.includes("PW___M") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW01_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW10_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW45_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW80_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW12_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW50_X") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW___M").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW01_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW10_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW45_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW12_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW50_X").length > 0 ? 1 : 0
    if(condition1 >= 1) {
      return true
    }
    return false
  }
  return true
}

// 酸溶解・金属元素(SOAP6X)関連チェック
function analizeItemRelationSOAP6X(value, vm) {
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("SOAP6X")) {
    let condition1 = 0
    
    condition1 += vm.AnalizeItems.includes("PW___M") ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW___M").length > 0 ? 1 : 0

    if(condition1 >= 1) {
      return true
    }
    return false
  }
  return true
}

// 灰化・酸溶解・金属分析(SOAP5X)関連チェック
function analizeItemRelationSOAP5X(value, vm) {
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("SOAP5X")) {
    let condition1 = 0
    
    condition1 += vm.AnalizeItems.includes("PW___M") ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW___M").length > 0 ? 1 : 0

    if(condition1 >= 1) {
      return true
    }
    return false
  }
  return true
}

// 環分析n-d-M法(RA___Z) 関連チェック
function analizeItemRelationRA___Z(value, vm) {
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("RA___Z")) {
    let condition1 = 0
    let condition2 = 0
    condition1 += vm.AnalizeItems.includes("SG___J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("RID__J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("V100_J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("V40__J") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S4__M") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S2___J") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "SG___J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "RID__J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "V100_J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "V40__J").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S4__M").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S2___J").length > 0 ? 1 : 0
    if(condition1 >= 4) {
      if(condition2 >= 1) {
        return true
      }
    }
    return false
  }
  return true
}

export default {
    beforeRouteLeave (to, from, next) {
      // console.log('router',to)
      if (this.$v.$anyDirty&&!this.isPageMove) {
        let answer = window.confirm("編集中のデータがあります。本当にこのページから離れますか？")
        if (answer) {
          next()
        } else {
          next(false)
        }
      } else {
        next()
      }
    },

  mixins:[validations, utilsMixin, generateUuid, utils],
  components:{
    sucDialog: entSuccessed,
    appDialog: isFailured,
    valiDialog: valiErrored,
    deleteSampleConfirm,
    samplingSuccessed,
  },
  head: {
    title: { inner: '分析サンプル採油'},
  },
  data: () => ({
    e6: 1,

    Name: "",
    SampleName: "",
    CustomerMachineID: "",
    MakerID: "",
    ModelNumber: "",
    PurchasedDate: "",
    SystemOil: null,
    SystemOilUnit: "",
    SystemOilUnitText: "",
    MachineMemo: "",
    OperatingTime: null,
    OperatingTimeUnit: "",
    OperatingTimeUnitText: "",
    TotalOperatingTime: null,
    TotalOperatingTimeUnit: "",
    TotalOperatingTimeUnitText: "",
    OilmakerID: "",
    OilmakerText: "",
    OilModelNumber: "",
    OilGrade: "",
    OilGradeText: "",

    isHazardousMaterials: "0",
    isAccept: "1",
    HazardousMaterialsDetail: "",
    HazardousMaterialsConfirmed: "",
    TrackingNumber: "",
    OilChangeDate: "",
    OilChange: null,
    OilChangeUnit: "",
    OilChangeUnitText: "",
    OilUsageTime: null,
    OilUsageTimeUnit: "",
    OilUsageTimeUnitText: "",

    isOilChanged: false,

    OilCondition: "",
    OilConditionText: "",
    OilConditionList: [
      {Text: "新油", Value:"01000000"},
      {Text: "使用油", Value:"02000000"},
    ],

    AnalizeTypeCategory: "",
    AnalizeType: "",
    AnalizeTypeName: "",
    AnalizeTypeGroup: "",
    beforeAnalizeType: "",
    beforeAnalizeTypeName: "",
    beforeAnalizeTypeGroup: "",

    AnalizeSet: "",
    AnalizeSetName: "",

    AnalizeItems: [],
    analizeItemNames: [],

    AnalizeItemSub: {},
    AnalizeItemSubError: {},

    StandardValue: "0",
    StandardValueName: "",
    StandardValueNoName: "分析規格が未選択です",
    Surplus: "0",
    Filter: "001",
    OfficeID: "",

    OilTypeList:[],
    OilTypeCategory:"",
    OilTypeCategoryText:"",
    OilType: "",
    OilTypeText: "",

    hasOilProperties: false,
    OilPropertyList:[
      {Value:"000", Text:"水溶性"},{Value:"000100", Text:"油性"},
    ],
    OilProperty:"",
    OilPropertyText:"",

    Ratio: 0,
    Rounding: 0,

    Price: 0,
    Fee: 0,
    SetPrice: 0,

    SetRequire: 0,
    Require: 0,

    FilterFee: 0,
    PriceString: "",

    Status: "00000000",

    SampleMemo: "",
    SamplingAt: "",
    SamplingBy: "",
    SamplingPlace: "",
    AnalizePurpose: "",
    BottleCount: 1,
    LatestOrderAt:"",
    LatestOrderNumber: "",
    success: false,
    show1: false,
    isConfirmed: false,
    menu2: false,
    menu3: false,
    // isSuccessed: false,
    isFailured: false,
    // isErrored: false,   
    isSelectAnalizeSet: false,  
    overlayStepper1: true,   
    isSwStandard: false,
    isPageMove: false,
    successUrl: '/',
    successText: '',
    valiErrorText: '申請内容に不備がございます<br>赤字のエラー箇所を修正ください</p>',
    failureUrl: '/mymachine',
    machineid: "",
    sampleid: "",
    isCreate: false,

    isErrorParam: false,
    ErrorInfo: "",

    analizeTypeGroupList: [],
    oilTypeCategoryList: [],

    analizeTypeList: [],
    analizeItemList: [],  // 該当分析区分の分析項目リスト
    analizeItemSubList: [],  // 該当分析区分の分析項目（サブ）リスト
    activeAnalizeItemList: [],  // 選択中のセットに含まれる項目を除いた分析リスト（依頼できる分析項目リスト）

    analizeSetItems: [], // セットに含まれる分析項目リスト

    oilChangeDatePicker: false,

    analizeSetList: [],
    standardValueList: [],

//    inquiry_url: process.env.VUE_APP_INQUIRY_URL,
    inquiry_url: "https://www.japan-analysts.com/contact/",
  }),
    validations() {
      let _validations = {
//        SampleName: { required, maxLength: maxLength(50) },
        OperatingTime: { useTime },
        OilChange: { float, hasOilChangeUnit },
        OilUsageTime: { useTime, hasOilUsageTimeUnit },
//        OilmakerID: { maxLength: maxLength(20)  },
//        OilModelNumber: { requiredPromptFumei, maxLength: maxLength(78) },
//        SamplingPlace: { alphaNumPlus, maxLength: maxLength(12) },
        BottleCount: { numeric, required },
        SampleMemo: { maxLength: maxLength(60) },
        StandardValue: { isStandardValue },
        AnalizeTypeGroup: { required },
        AnalizeType: { required },
        AnalizeSet: { isAnalizeSet },
//        AnalizeItems: { isAnalizeSet, analizeItemRelations, analizeItemRelationPCSA1, analizeItemRelationPCSA2, analizeItemRelationVI___J, analizeItemRelationGCVC_J, analizeItemRelationNCVC_J, analizeItemRelationCETINJ },
        AnalizeItems: { isAnalizeSet, analizeItemRelations, analizeItemRelationPCSA1, analizeItemRelationPCSA2, analizeItemRelationVI___J, analizeItemRelationGCVC_J, analizeItemRelationNCVC_J, analizeItemRelationCETINJ, analizeItemRelationPHO__X, analizeItemRelationPHO2_X,analizeItemRelationSOAP6X,analizeItemRelationSOAP5X,analizeItemRelationRA___Z },
        AnalizeItemSub: {analizeItemRelations},
        HazardousMaterialsDetail: { hasHazardousMaterialsDetail },
        OilTypeCategory: { required },
        OilType: { required },
        OilTypeText: { required, maxLength: maxLength(20) },
        OilProperty: { requiredOilProperty },
      }
      if (this.AnalizeTypeCategory == '一般') {
        _validations["SampleName"] = { required, maxLength: maxLength(20) }
        _validations["OilmakerID"] =  { maxLength: maxLength(20) }
        _validations["OilModelNumber"] = { requiredPromptFumei, maxLength: maxLength(20) }
        _validations["SamplingBy"] = {  maxLength: maxLength(20) }
        _validations["SamplingPlace"] = { maxLength: maxLength(20) }
        _validations["SamplingAt"] = { }
      }else {
        _validations["SampleName"] = { required, alphaNumPlus, maxLength: maxLength(15) }
        _validations["OilmakerID"] =  { alphaNumPlus, maxLength: maxLength(20) }
        _validations["OilModelNumber"] = { requiredPromptFumeiEn, alphaNumPlus, maxLength: maxLength(15) }
        _validations["SamplingBy"] = { alphaNumPlus, maxLength: maxLength(12) }
        _validations["SamplingPlace"] = { alphaNumPlus, maxLength: maxLength(12) }
        _validations["SamplingAt"] = { }
      }
      return _validations
    },
    computed: {
    SampleNameErrors () {
        return this.defaultMessage(this.$v.SampleName)
    },
    SamplingAtErrors () {
        return this.defaultMessage(this.$v.SamplingAt)
    },
    BottleCountErrors () {
        return this.defaultMessage(this.$v.BottleCount)
    },
    SampleMemoErrors () {
        return this.defaultMessage(this.$v.SampleMemo)
    },
    StandardValueErrors () {
        return this.defaultMessage(this.$v.StandardValue)
    },
    SamplingByErrors () {
      return this.defaultMessage(this.$v.SamplingBy)
    },
    AnalizeTypeGroupErrors () {
        return this.defaultMessage(this.$v.AnalizeTypeGroup)
    },
    AnalizeSetErrors () {
        return this.defaultMessage(this.$v.AnalizeSet)
    },
    AnalizeItemsErrors () {
      return this.defaultMessage(this.$v.AnalizeItems)
    },
    OilChangeErrors () {
        return this.defaultMessage(this.$v.OilChange)
    },
    OilUsageTimeErrors () {
        return this.defaultMessage(this.$v.OilUsageTime)
    },
    OilmakerIDErrors () {
        return this.defaultMessage(this.$v.OilmakerID)
    },
    OilModelNumberErrors () {
        return this.defaultMessage(this.$v.OilModelNumber)
    },
    HazardousMaterialsDetailErrors () {
        return this.defaultMessage(this.$v.HazardousMaterialsDetail)
    },
    OilTypeCategoryErrors () {
        return this.defaultMessage(this.$v.OilTypeCategory)
    },
    OilTypeErrors () {
        return this.defaultMessage(this.$v.OilType)
    },
    OilTypeTextErrors() {
      return this.defaultMessage(this.$v.OilTypeText)
    },
    OilPropertyErrors() {
      return this.defaultMessage(this.$v.OilProperty)
    },
    SamplingPlaceErrors() {
      return this.defaultMessage(this.$v.SamplingPlace)
    },
    useUnits () {
      return this.$store.state.useUnits
    },
    liquidUnits () {
      return this.$store.state.liquidUnits
    },
    analizeFee() {
      return this.Fee + this.FilterFee
    },
    samplingmode() {
      if(this.isCreate) return "登録"
      else return "更新"
    },
    getNoticeType () {
      if (this.isHazardousMaterials == "1"){
        if(this.isAccept == "1") {
          // 危険物を含む 且つ 分析・診断サービス利用可
          return 1
        }else {
          // 危険物を含む 且つ 分析・診断サービス利用不可
          return 2
        }
      }else {
        if(this.isAccept == "1") {
          // 危険物を含まない 且つ 分析・診断サービス利用可
          return 3
        }else {
          // 危険物を含まない 且つ 分析・診断サービス利用不可
          return 4
        }
      }
    }

  },
  methods: {
    changeStepper: function(step) {
      let next = this.validation(step) 
      this.e6 = next
    },
    validation: function (step) {
      console.log("validation", step)
      if(step >= 2) {
        this.$v.OilTypeCategory.$touch()
        this.$v.OilType.$touch()
        this.$v.OilProperty.$touch()
        this.$v.OilmakerID.$touch()
        this.$v.OilModelNumber.$touch()
        this.$v.OilUsageTime.$touch()
        this.$v.HazardousMaterialsDetail.$touch()
        if (this.$v.OilTypeCategory.$invalid ||
            this.$v.OilType.$invalid ||
            this.$v.OilProperty.$invalid ||
            this.$v.OilmakerID.$invalid ||
            this.$v.OilModelNumber.$invalid ||
            this.$v.OilUsageTime.$invalid
        ){
          console.log('error: ', 'validation error Page1')
          this.$refs.isErrored.open();
          this.isErrored = true
          this.processing = false
          return 1
        }
      }
      
      if(step >= 3) {
        this.$v.AnalizeTypeGroup.$touch()
        this.$v.AnalizeSet.$touch()
        this.$v.AnalizeItems.$touch()
        if (this.$v.AnalizeTypeGroup.$invalid ||
            this.$v.AnalizeSet.$invalid ||
            this.$v.AnalizeItems.$invalid
        ){
          console.log('error: ', 'validation error Page1')
          this.$refs.isErrored.open();
          this.isErrored = true
          this.processing = false
          return 2
        }
      }

      if(step >= 4) {
        this.$v.SampleName.$touch()
        this.$v.SamplingAt.$touch()
        this.$v.BottleCount.$touch()
        this.$v.SamplingBy.$touch()
        this.$v.SamplingPlace.$touch()
        if (this.$v.SampleName.$invalid ||
            this.$v.SamplingAt.$invalid ||
            this.$v.BottleCount.$invalid ||
            this.$v.SamplingBy.$invalid ||
            this.$v.SamplingPlace.$invalid
        ){
          console.log('error: ', 'validation error Page1')
          this.$refs.isErrored.open();
          this.isErrored = true
          this.processing = false
          return 3
        }

      }

      this.processing = false
      return step
    },
    confirmCreateMachine: async function() {
      let val = this.validation(4)
      if(val == 4) {
        this.isConfirmed=true
      }
    },

      createSample: async function () {
        this.isConfirmed = false
/*
        this.$v.$touch()
        if (this.$v.$invalid) {
          if (this.$v.OilmakerID.$invalid ||
            this.$v.OilModelNumber.$invalid ||
            this.$v.OilTypeCategory.$invalid ||
            this.$v.OilType.$invalid
          ) {
            console.log('error: ', 'validation error')
            // this.isErrored = true
            this.$refs.isErrored.open();          
            this.e6 = 1
            return
          }else if (this.$v.AnalizeTypeGroup.$invalid ||
            this.$v.AnalizeSet.$invalid
          ) {
            console.log('error: ', 'validation error')
            // this.isErrored = true
            this.$refs.isErrored.open();          
            this.e6 = 2
            return
          }else {
            console.log('error: ', 'validation error')
            // this.isErrored = true
            this.$refs.isErrored.open();          
            this.e6 = 3
            return
          }
        } 
*/
        let _HazardousMaterialsConfirmed = ""
        // 危険物あり且つ確認済みチェック未の場合は一時保存
        // それ以外（危険物がないか、危険物あり且つ確認済みチェック済みは完了
        if((this.isHazardousMaterials == "1") && (this.HazardousMaterialsConfirmed != true)) {
          this.Status = "00000000"
          _HazardousMaterialsConfirmed = "0"
        }else if((this.isHazardousMaterials == "1") && (this.HazardousMaterialsConfirmed == true)) {
          this.Status = "10000000"
          _HazardousMaterialsConfirmed = "1"
        }else {
          this.Status = "10000000"
          _HazardousMaterialsConfirmed = ""
        }

        // fload型の要素はnullに変換
        if(this.OilUsageTime == "") {
          this.OilUsageTime = null
        }

        if(this.SamplingAt == null) {
          this.SamplingAt = ""
        }

        //サンプリング直後（まだ依頼に出していない）データのOfficeIDは、OfficeID + "-00000000"で設定
        //依頼されたときに、正しいOfficeIDに更新する。
        //マイ機器なしサンプルは、マシンIDを0000000000で登録
        const sample = {
//          id: uuid,
          OfficeID: this.$store.state.operatingOffice.OfficeID + "-00000000",
          // SamplingAt: "2020/6/8",
          SamplingAt: this.SamplingAt,
          Name: this.SampleName,
          CustomerMachineID: this.CustomerMachineID,
          MachineID: "0000000000",
          MakerID: this.MakerID,
          ModelNumber: this.ModelNumber,
          PurchasedDate: this.PurchasedDate,
          SystemOil: this.SystemOil,
          SystemOilUnit: this.SystemOilUnit,
          SystemOilUnitText: this.SystemOilUnitText,
          MachineMemo: this.MachineMemo,
          OperatingTime: this.OperatingTime,
          OperatingTimeUnit: this.OperatingTimeUnit,
          OperatingTimeUnitText: this.OperatingTimeUnitText,
          OilmakerID: this.OilmakerID,
          OilModelNumber: this.OilModelNumber,
          OilTypeCategory: this.OilTypeCategory,
          OilTypeCategoryText: this.OilTypeCategoryText,
          OilType: this.OilType,
          OilTypeText: this.OilTypeText,
          OilProperty: this.OilProperty,
          OilPropertyText: this.OilPropertyText,
          isHazardousMaterials: this.isHazardousMaterials,
          HazardousMaterialsDetail: this.HazardousMaterialsDetail,
          OilChangeDate: this.OilChangeDate,
          OilChange: this.OilChange,
          OilChangeUnit: this.OilChangeUnit,
          OilChangeUnitText: this.OilChangeUnitText,
          OilUsageTime: this.OilUsageTime,
          OilUsageTimeUnit: this.OilUsageTimeUnit,
          OilUsageTimeUnitText: this.OilUsageTimeUnitText,
          AnalizeTypeGroup: this.AnalizeTypeGroup,
          AnalizeTypeGroupName: this.AnalizeTypeGroup,
          AnalizeType: this.AnalizeType,
          AnalizeTypeName: this.AnalizeTypeName,
          AnalizeSet: this.AnalizeSet,
          AnalizeSetName: this.AnalizeSetName,
          AnalizeItems: JSON.stringify(this.AnalizeItems),
          AnalizeItemSub: JSON.stringify(this.AnalizeItemSub),
          AnalizePurpose: this.AnalizePurpose,
          StandardValue: this.StandardValue,
          StandardValueName: this.StandardValueName,
          Surplus: this.Surplus,
          Filter: this.Filter,
          ApplicationID: "00000000",
          Memo: this.SampleMemo,
          SamplingBy: this.SamplingBy,
          SamplingPlace: this.SamplingPlace,          
          BottleCount: this.BottleCount,
          Price: this.Price + this.FilterFee,
          Fee: this.Fee + this.FilterFee,
          Quantity: this.Require,
          Status: this.Status,
          HazardousMaterialsConfirmed: _HazardousMaterialsConfirmed,
          TrackingNumber: this.TrackingNumber,
          OilCondition: this.OilCondition,
          OilConditionText: this.OilConditionText,

        }

        console.log("sample", sample)

        if(this.isCreate) {
          //Sample.idの値を自己生成 形式は4×4
//        let uuid = ""
//          uuid = this.generateUuid("xxxx-xxxx-4xxx-yxxx")
          sample["id"] = this.generateUuid("xxxx-xxxx-4xxx-yxxx")
          try {
            console.log('sample', sample)
            await API.graphql(graphqlOperation(createSample, {input: sample}))
            console.log('success', sample)
            // this.isSuccessed = true
            window.removeEventListener("beforeunload", this.handler)
            this.isPageMove=true
            this.successText = '分析サンプル情報を登録しました。<br><br>お申込みページの「登録済み分析サンプル」でご確認いただけます。',
            this.$refs.isSamplingSuccessed.open();
          } catch (error) {
            console.log('error: ', error)
            // this.isFailured = true
            this.$refs.isFailured.open();
          }
        }else {
          sample["id"] = this.sampleid
          try {
            console.log('sample', sample)
            await API.graphql(graphqlOperation(updateSample, {input: sample}))
            console.log('success', sample)
            // this.isSuccessed = true
            window.removeEventListener("beforeunload", this.handler)
            this.isPageMove=true
            this.successText = '分析サンプル情報を更新しました。<br><br>お申込みページの「登録済み分析サンプル」でご確認いただけます。',
            this.$refs.isSuccessed.open();
          } catch (error) {
            console.log('error: ', error)
            // this.isFailured = true
            this.$refs.isFailured.open();
          }
        }
      },
      changeAnalizeTypeGroup: async function() {
          this.isSelectAnalizeSet = false
          const typeGroup = this.analizeTypeGroupList.filter(item => item.Value  == this.AnalizeTypeGroup)
          this.analizeTypeList = await this.getAnalizeTypeList(this.AnalizeTypeGroup)
          this.AnalizeTypeGroupName = typeGroup[0].Text

          if(this.OilTypeCategory){
            this.AnalizeType = String(Number(typeGroup[0].Code) + Number(this.OilTypeCategory))
            this.changeAnalizeType()
        }
      },

      changeAnalizeType: async function () {
          this.isSelectAnalizeSet = false
          this.analizeSetList = await this.getAnalizeSetList(this.AnalizeType)
          this.analizeItemList = await this.getAnalizeItemList(this.AnalizeType)
          this.activeAnalizeItemList = this.analizeItemList
          this.analizeItemSubList = await this.getAnalizeItemSubList(this.AnalizeType)

/* 一旦削除！
          const standardvaluelist = this.$store.state.standardValueList.filter(item => item.AnalizeType  == this.AnalizeType)
          this.standardValueList = standardvaluelist[0].standardValues
*/

          this.AnalizeSet = ""
          this.AnalizeSetName = ""
          this.AnalizeItems = ""
          this.AnalizeItemSub = {}
          this.StandardValue = ""
          this.StandardValueName = ""

          this.Price = 0
          this.Fee = 0
          this.Require = 0
          this.SetPrice = 0
          this.SetRequire = 0

          const AnalizeTypeName = this.analizeTypeList.filter(item => item.Value  == this.AnalizeType)
          this.AnalizeTypeName = AnalizeTypeName[0].Text

      },
      changeAnalizeSet: async function () {
        this.isSelectAnalizeSet = false
        if (this.AnalizeSet) {
          // セットが選びなおされた場合、個別分析項目をリセットする（セットと重複することがあるため）
          this.AnalizeItems = []

          const AnalizeSetName = this.analizeSetList.filter(item => item.Value  == this.AnalizeSet)
          this.AnalizeSetName = AnalizeSetName[0].Text
          this.analizeSetItems = []

          this.activeAnalizeItemList = await this.excludeAnalizeItems(AnalizeSetName[0].AnalizeItems, this.analizeItemList)

          this.analizeSetItems = await this.getAnalizeSetItems(AnalizeSetName[0])
          this.isSelectAnalizeSet = true

          this.SetPrice = AnalizeSetName[0].Price
          this.SetRequire = AnalizeSetName[0].Require
          this.Price = this.SetPrice
          this.Fee = this.SetPrice
          this.Require = this.SetRequire
        } else {
          this.activeAnalizeItemList = this.analizeItemList

          this.AnalizeSet = ""
          this.AnalizeSetName = ""
          this.analizeSetItems = []
          this.Price = this.Price - this.SetPrice
          this.Fee = this.Fee - this.SetPrice
          this.Require = this.Require - this.SetRequire
          this.SetPrice = 0
          this.SetRequire = 0
        }
        await this.changeAnalizeItems(this.AnalizeItems)
      },
      changeStandardValue: async function () {
          const StandardValueName = this.standardValueList.filter(item => item.Value  == this.StandardValue)
          if (StandardValueName[0]) {
            this.StandardValueName = StandardValueName[0].Text
            // console.log('StandardValueName', this.StandardValueName)
          }
          if (!this.StandardValue) { this.StandardValueName = "" }
      },
      changeSwStandard: async function () {
        // console.log('changeSwStandard')
          if (this.isSwStandard == false) {
            this.StandardValue = ""
            this.StandardValueName = ""
          }
      },
      changeAnalizeItems: async function (selecteditems) {
        for (var parentItem of Object.keys(this.analizeItemSubList)) {
          if(selecteditems.includes(parentItem)) {
            // サブ項目がある分析項目がえらばれている場合は配列をセット（継続）
            let selectedSub = this.AnalizeItemSub[parentItem]
            if(selectedSub == undefined) {
              selectedSub = []
            }
//            this.AnalizeItemSub[parentItem] = selectedSub
            this.$set(this.AnalizeItemSub, parentItem, selectedSub);
          }else {
            const includeSet = this.analizeSetItems.filter(item => item.Value  == parentItem)
            if(!includeSet[0]) {
              // サブ項目がある分析項目が選ばれていなかった且つ、セットにも含まれていない場合は削除（リセット）
              delete this.AnalizeItemSub[parentItem]
            }else {
              let selectedSub = this.AnalizeItemSub[parentItem]
              if(selectedSub == undefined) {
                selectedSub = []
              }
              this.$set(this.AnalizeItemSub, parentItem, selectedSub);
            }
          }
        }

        this.analizeItemNames = await this.getAnalizeItemNames(this.AnalizeItems, this.AnalizeItemSub, this.analizeItemList, this.analizeItemSubList)
        console.log("analizeItemNames:", this.analizeItemNames)

        this.calcAnalizeItemPriceAll()
      },
      changeAnalizeItemSub: async function() {
        this.analizeItemNames = await this.getAnalizeItemNames(this.AnalizeItems, this.AnalizeItemSub, this.analizeItemList, this.analizeItemSubList)
        console.log("analizeItemNames:", this.analizeItemNames)
        
        this.calcAnalizeItemPriceAll()

        // 強制的に個別分析項目のvalidationを実行させるために値を一次的に変更
        //値が変わらないとtouchが実行されない=validationsが実行されない        
        this.AnalizeItems.push("dummy")
        this.AnalizeItems.pop("dummy")
        this.$v.AnalizeItems.$touch()
      },
      calcAnalizeItemPriceAll: function() {
        this.Price = this.SetPrice
        this.Fee = this.SetPrice
        this.Require = this.SetRequire

        for (var selecteditem of this.AnalizeItems) {
          let itemlist = this.analizeItemList.filter(item => item.Value  == selecteditem)
          this.calcAnalizeItemPrice(itemlist[0])
          this.Require = this.Require + Number(itemlist[0].Require)
        }

        if(this.AnalizeItemSub) {
          for (var parentItem of Object.keys(this.AnalizeItemSub)) {
              let _analizeItemSubList = this.analizeItemSubList[parentItem]
              for (var selecteditemsub of this.AnalizeItemSub[parentItem]) {
                let itemlist = _analizeItemSubList.filter(item => item.Value  == selecteditemsub)
                this.calcAnalizeItemPrice(itemlist[0])
                this.Require = this.Require + Number(itemlist[0].Require)
              }
            }
        }
      },
      calcAnalizeItemPrice: function(item) {
        let price = Number(item.Price)
        let fee = this.getAnalizeItemFee(item,this.Ratio,this.Rounding)
        let discount = price - fee

        this.Price = this.Price + price
        this.Fee = this.Fee + fee
        this.Discount = this.Discount + discount
        this.consolelogPrice()
      },
      changeFilter: async function (selecteditem) {
        this.computeFilterFee(selecteditem)
      },
      changeOilTypeCategory: async function() {
//        const oilTypeCategorys = this.$store.state.oilTypeCategoryList.filter(item => item.Value  == this.OilTypeCategory)
        const oilTypeCategorys = this.oilTypeCategoryList.filter(item => item.Value  == this.OilTypeCategory)
        this.OilTypeCategoryText = oilTypeCategorys[0].Text
        // オイルの種類のリストを更新
/*
        const oilTypes = this.$store.state.oilTypeList.filter(item => item.OilTypeCategory  == this.OilTypeCategory)
        this.OilTypeList = oilTypes[0].OilType
*/
        this.OilTypeList = await this.getOilTypeList(this.OilTypeCategory + this.AnalizeTypeCategory)
        this.OilType = ""
        this.OilTypeText = ""
        this.isHazardousMaterials = "0"
        this.isAccept = "1"

        // 分析方法が選択済みの場合、分析区分を自動設定
        // 合わせて、セット分析のリスト、個別分析項目のリストを更新
        const analizeTypeGroup = this.analizeTypeGroupList.filter(item => item.Value  == this.AnalizeTypeGroup)
        if(analizeTypeGroup[0]) {
          this.AnalizeType = String(Number(analizeTypeGroup[0].Code) + Number(this.OilTypeCategory))

          this.changeAnalizeType()
        }
      },
      changeOilType: async function() {
        const oilType = this.OilTypeList.filter(item => item.Value  == this.OilType)
        this.OilTypeText = oilType[0].Text
        this.isHazardousMaterials = oilType[0].isHazardousMaterials
        this.isAccept = oilType[0].isAccept
        if(oilType[0].Properties == "true") {
          this.hasOilProperties = true
        }else {
          this.hasOilProperties = false
        }
        this.OilProperty = ""
        this.OilPropertyText = ""        
      },
      changeOilProperty: async function() {
        const oilProperty = this.OilPropertyList.filter(item => item.Value  == this.OilProperty)
        this.OilPropertyText = oilProperty[0].Text
      },
      changeOilChangeUnit: async function () {
        if(this.OilChangeUnit) {
          const OilChangeUnitNames = this.liquidUnits.filter(item => item.Value == this.OilChangeUnit)
          this.OilChangeUnitText = OilChangeUnitNames[0].Text
        }else {
          this.OilChangeUnit = null
          this.OilChangeUnitText = ""
        }
      },
      changeOilCondition: async function() {
        const oilCondition = this.OilConditionList.filter(item => item.Value == this.OilCondition)
        this.OilConditionText = oilCondition[0].Text
      },
      computeFilterFee: function(filter) {
        switch (filter){
          case "001": // なし
            this.FilterFee = 0;
            break
          case "002": // ラミネート加工 1700円
            this.FilterFee = 1700;
            break
          default: // case 003 ラミネート加工なし 600円
            this.FilterFee = 600;
            break
        }
        console.log('FilterFee', this.FilterFee)
      },
      consolelogPrice() {

        let pricelog = {
          SetPrice: this.SetPrice,
          SetRequire: this.SetRequire,
          Price: this.Price,
          Fee: this.Fee,
          Require: this.Require,
          FilterFee: this.FilterFee,
          Discount: this.Discount,
        }
        console.log("price log", pricelog)

      },
      changeOilUsageTimeUnit: async function () {
        if(this.OilUsageTimeUnit) {
          const OilUsageTimeUnitNames = this.useUnits.filter(item => item.Value == this.OilUsageTimeUnit)
          this.OilUsageTimeUnitText = OilUsageTimeUnitNames[0].Text
        }else {
          this.OilUsageTimeUnit = null
          this.OilUsageTimeUnitText = ""
        }
      },
      getAnalizeItemName(analizeItem) {
        let item = this.analizeItemList.filter(item => item.Value  == analizeItem)
        return item[0].Text

      },      
      back: async function () {
        this.$router.back()
      },
      handler (event) {
        event.returnValue = "Data you've inputted won't be synced"
        console.log('ページ離脱')
      },
      showDialog() {
        this.$refs.deletedialog.open();
      },
      openInquiry() {
          window.open(this.inquiry_url, '_blank')
      },
  },
  mounted: async function () {
    console.log('id: ', this.$route.query.id)

    //直接サンプルは"一般"のみ対応
//    this.AnalizeTypeCategory = "一般"
    this.AnalizeTypeCategory = this.$route.query.category
    console.log("AnalizeTypeCategory:", this.AnalizeTypeCategory)
/*
    this.analizeTypeGroupList = await this.getAnalizeTypeGroupList(this.AnalizeTypeCategory)
    console.log("this.analizeTypeGroupList:", this.analizeTypeGroupList)

    this.oilTypeCategoryList = await this.getOilTypeCategoryList(this.AnalizeTypeCategory)
    console.log("this.oilTypeCategoryList:", this.oilTypeCategoryList)
*/
    this.Ratio = Number(this.$store.state.operatingCompany.Ratio) / 100
    this.Rounding = this.$store.state.operatingCompany.Rounding
    console.log("SpotSampling", {Ratio: this.Ratio, Rounding: this.Rounding})

    //「mode」が指定されていない場合は新規登録。「id」は指定されない
    //「mode」が指定されている場合は更新。「id」はサンプルID
    //※現時点でmodeは新規作成か更新のみのためif-elseで実装
    let updatesample = {}
    if (this.$route.query.id == undefined){
      console.log('create sample: ', this.$route.query.id)
      this.isCreate = true

      // 航空機の場合、使用時間系の単位はHr固定
      if(this.AnalizeTypeCategory == "航空機") {
        this.OilUsageTimeUnit = "10000002"
        this.OilUsageTimeUnitText = ""
/*
      this.TotalOperatingTimeUnit = "10000002"
      this.TotalOperatingTimeUnitText = ""
      this.SinceOverhaulTimeUnit = "10000002"
      this.SinceOverhaulTimeUnitText = ""
      this.FilterUsageTimeUnit = "10000002"
      this.FilterUsageTimeUnitText = ""
*/
      }      
//      this.overlayStepper1 = false
//      return
    }else {
      console.log('update sample: ', this.$route.query.id)
      this.isCreate = false
      this.sampleid = this.$route.query.id
      updatesample = await API.graphql(graphqlOperation(getSample, {id: this.sampleid}))
      if(!updatesample.data.getSample) {
        this.isErrorParam = true
        this.ErrorInfo = "notExist"
        this.overlayStepper1 = false
        console.log('isErrorParam: ', this.isErrorParam)
        return
      }
      this.AnalizeTypeCategory = this.getSampleAnalizeTypeCategory(updatesample.data.getSample)
    }

    this.analizeTypeGroupList = await this.getAnalizeTypeGroupList(this.AnalizeTypeCategory)
    console.log("this.analizeTypeGroupList:", this.analizeTypeGroupList)

    this.oilTypeCategoryList = await this.getOilTypeCategoryList(this.AnalizeTypeCategory)
    console.log("this.oilTypeCategoryList:", this.oilTypeCategoryList)

    this.SetPrice = 0
    this.SetRequire = 0
    this.Price = 0
    this.Fee = 0
    this.Require = 0

    //更新コードの場合は、該当サンプル情報を上書きセット
    if(!this.isCreate) {
      let _AnalizeItems = []
      let _OilTypeCategory
      let _OilType
      let _AnalizeItemSub = {}

      this.OilmakerID = updatesample.data.getSample.OilmakerID
      this.OilModelNumber = updatesample.data.getSample.OilModelNumber
//      this.OilTypeCategory = updatesample.data.getSample.OilTypeCategory
      _OilTypeCategory = updatesample.data.getSample.OilTypeCategory
      _OilType = updatesample.data.getSample.OilType
      this.OilTypeCategoryText = updatesample.data.getSample.OilTypeCategoryText
      this.OilTypeText = updatesample.data.getSample.OilTypeText
      let _OilProperty = updatesample.data.getSample.OilProperty
      let _OilPropertyText = updatesample.data.getSample.OilPropertyText
      this.OilUsageTime = updatesample.data.getSample.OilUsageTime
      this.OilUsageTimeUnit = updatesample.data.getSample.OilUsageTimeUnit
      this.OilUsageTimeUnitText = updatesample.data.getSample.OilUsageTimeUnitText
      this.isHazardousMaterials = updatesample.data.getSample.isHazardousMaterials
      this.HazardousMaterialsDetail = updatesample.data.getSample.HazardousMaterialsDetail
      this.SamplingAt = updatesample.data.getSample.SamplingAt
      this.SamplingBy = updatesample.data.getSample.SamplingBy
      this.SamplingPlace = updatesample.data.getSample.SamplingPlace
      this.SampleName = updatesample.data.getSample.Name
      this.AnalizeTypeGroup = updatesample.data.getSample.AnalizeTypeGroup
      this.AnalizeTypeGroupName = updatesample.data.getSample.AnalizeTypeGroupName
      this.AnalizeType = updatesample.data.getSample.AnalizeType
      this.AnalizeTypeName = updatesample.data.getSample.AnalizeTypeName
      this.AnalizeSet = updatesample.data.getSample.AnalizeSet
      this.AnalizeSetName = updatesample.data.getSample.AnalizeSetName
      _AnalizeItems = JSON.parse(updatesample.data.getSample.AnalizeItems)

      this.AnalizeItemSub = {}
      if(updatesample.data.getSample.AnalizeItemSub != undefined) {
        _AnalizeItemSub = JSON.parse(updatesample.data.getSample.AnalizeItemSub)
      }
      this.AnalizePurpose = updatesample.data.getSample.AnalizePurpose

      this.StandardValue = updatesample.data.getSample.StandardValue
      this.StandardValueName = updatesample.data.getSample.StandardValueName
      this.Surplus = updatesample.data.getSample.Surplus
      this.Filter = updatesample.data.getSample.Filter
      this.SampleMemo = updatesample.data.getSample.Memo
      this.BottleCount = updatesample.data.getSample.BottleCount
      this.Status = updatesample.data.getSample.Status
      if(updatesample.data.getSample.HazardousMaterialsConfirmed == "1"){
        this.HazardousMaterialsConfirmed = true
      }else {
        this.HazardousMaterialsConfirmed = false
      }
      this.TrackingNumber = updatesample.data.getSample.TrackingNumber
      this.OilCondition = updatesample.data.getSample.OilCondition
      this.OilConditionText = updatesample.data.getSample.OilConditionText

      await this.changeAnalizeTypeGroup()
      this.analizeTypeList = await this.getAnalizeTypeList(this.AnalizeTypeGroup)
      this.analizeSetList = await this.getAnalizeSetList(this.AnalizeType)
      this.analizeItemList = await this.getAnalizeItemList(this.AnalizeType)
      this.activeAnalizeItemList = this.analizeItemList
      this.analizeItemSubList = await this.getAnalizeItemSubList(this.AnalizeType)

/* 一旦削除！
    let standardvaluelist = this.$store.state.standardValueList.filter(item => item.AnalizeType  == this.AnalizeType)
    this.standardValueList = standardvaluelist[0].standardValues
*/

      const OperatingTimeUnitName = this.useUnits.filter(item => item.Value  == this.OperatingTimeUnit)
      if (OperatingTimeUnitName[0]) {
        this.OperatingTimeUnitText = OperatingTimeUnitName[0].Text
      }
      const OilChangeUnitName = this.liquidUnits.filter(item => item.Value  == this.OilChangeUnit)
      if (OilChangeUnitName[0]) {
        this.OilChangeUnitText = OilChangeUnitName[0].Text
      }
      const AnalizeTypeName = this.analizeTypeList.filter(item => item.Value  == this.AnalizeType)
      if (AnalizeTypeName[0]) {
        this.AnalizeTypeName = AnalizeTypeName[0].Text
        this.beforeAnalizeTypeName = AnalizeTypeName[0].Text
      }

//    const AnalizeSetName = this.analizeSetList.filter(item => item.Value  == this.AnalizeSet)
//    if (AnalizeSetName[0]) {
      if(this.AnalizeSet) {
        const AnalizeSetName = this.analizeSetList.filter(item => item.Value  == this.AnalizeSet)
        this.AnalizeSetName = AnalizeSetName[0].Text

        this.analizeSetItems = []
        this.activeAnalizeItemList = await this.excludeAnalizeItems(AnalizeSetName[0].AnalizeItems, this.analizeItemList)

        this.analizeSetItems = await this.getAnalizeSetItems(AnalizeSetName[0])
        this.isSelectAnalizeSet = true

        this.SetPrice = AnalizeSetName[0].Price
        this.SetRequire = AnalizeSetName[0].Require
        this.Price = this.SetPrice
        this.Fee = this.SetPrice
        this.Require = this.SetRequire
      }
      
      for (var AnalizeItem of _AnalizeItems) {
        let itemlist = this.analizeItemList.filter(item => item.Value  == AnalizeItem)
        this.Price = this.Price + Number(itemlist[0].Price)
        this.Fee = this.Fee + this.getAnalizeItemFee(itemlist[0],this.Ratio,this.Rounding)
        this.Require = this.Require + Number(itemlist[0].Require)
      }
      this.AnalizeItems = _AnalizeItems

      this.AnalizeItemSub = _AnalizeItemSub

      const StandardValueName = this.standardValueList.filter(item => item.Value  == this.StandardValue)
      if (StandardValueName[0]) {
        this.StandardValueName = StandardValueName[0].Text
        this.isSwStandard = true 
      }

      this.OilTypeCategory = _OilTypeCategory
/*
    const oilTypes = this.$store.state.oilTypeList.filter(item => item.OilTypeCategory  == this.OilTypeCategory)
    if(oilTypes[0]) {
      this.OilTypeList = oilTypes[0].OilType
      this.OilType = _OilType
    }
*/
      this.OilTypeList = await this.getOilTypeList(this.OilTypeCategory + this.AnalizeTypeCategory)
      this.OilType = _OilType

      await this.changeOilType()
      this.OilProperty = _OilProperty
      this.OilPropertyText = _OilPropertyText

      this.calcAnalizeItemPriceAll()
    }

    // 航空機の場合、使用時間系の単位はHr固定
    if(this.AnalizeTypeCategory == "航空機") {
      this.OilUsageTimeUnit = "10000002"
      this.OilUsageTimeUnitText = ""
/*
      this.TotalOperatingTimeUnit = "10000002"
      this.TotalOperatingTimeUnitText = ""
      this.SinceOverhaulTimeUnit = "10000002"
      this.SinceOverhaulTimeUnitText = ""
      this.FilterUsageTimeUnit = "10000002"
      this.FilterUsageTimeUnitText = ""
*/
    }

    this.overlayStepper1 = false
  },
  created () {
    window.addEventListener("beforeunload", this.handler)
  },
  destroyed () {
    window.removeEventListener("beforeunload", this.handler)
  }      
}
</script>
<style scoped>
.agree-text /deep/ label {
    color: black;
}
.label-chip {
  margin-right : 10px;
  width: 150px;
}
.vertical-align-middle{
    vertical-align:middle;
}
.wrap-text {
  overflow-wrap: break-all;
  word-break: break-all;
  white-space: pre-line;
}
</style>
